import useIsMobile from 'utils/hooks/useIsMobile'
import {KeyboardDoubleArrowRight} from '@mui/icons-material'
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  TextField,
} from '@mui/material'
import _ from 'lodash'
import {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {normalAlert} from 'utils/CustomAlert/Alert'
import './CustomPagination.css'
const CustomPagination = (props: any) => {
  const {filter, setFilter, totalCount, mini} = props
  const isMobile = useIsMobile()
  const pageInfo = useSelector((state: any) => state.pageInfo)
  const inputRef: any = useRef(null)
  const [movePage, setMovePage] = useState<any>(1)
  useEffect(() => {
    setMovePage('')
  }, [filter.rowPerPage])
  useEffect(() => {
    setMovePage(filter.page)
  }, [filter.page])

  const totalPages = Math.ceil(totalCount / (filter?.rowPerPage || 1))

  if (isMobile) {
    return (
      <div className='flex items-center justify-between gap-2 mt-3 px-2'>
        <FormControl size='small' sx={{minWidth: 100}}>
          <Select
            value={filter?.rowPerPage}
            onChange={(e) => setFilter({...filter, page: 1, rowPerPage: e.target.value})}
          >
            {_.map(pageInfo.selectPageSize, (el: any, i: number) => (
              <MenuItem value={el} key={i}>{el}개</MenuItem>
            ))}
          </Select>
        </FormControl>

        <div className='flex items-center gap-2'>
          <Button
            variant='outlined'
            size='small'
            disabled={filter?.page <= 1}
            onClick={() => setFilter({...filter, page: filter.page - 1})}
            sx={{minWidth: 36, px: 1}}
          >
            ‹
          </Button>
          <span className='text-base font-semibold whitespace-nowrap'>
            {filter?.page} / {totalPages}
          </span>
          <Button
            variant='outlined'
            size='small'
            disabled={filter?.page >= totalPages}
            onClick={() => setFilter({...filter, page: filter.page + 1})}
            sx={{minWidth: 36, px: 1}}
          >
            ›
          </Button>
        </div>
      </div>
    )
  }

  return (
    <>
      {!mini && (
        <div
          className={'mt-3 d-flex gap-3 justify-content-center align-items-center '}
          style={{marginTop: 15}}
        >
          <Pagination
            count={Math.ceil(totalCount / (filter?.rowPerPage || 1))}
            color='primary'
            size={'large'}
            variant='outlined'
            shape='rounded'
            defaultPage={1}
            siblingCount={4}
            page={filter?.page}
            onChange={(e, page) => {
              setFilter({...filter, page: page})
              setMovePage(page)
            }}
          />
          <div className={'d-flex gap-2'}>
            <TextField
              variant={'outlined'}
              ref={inputRef}
              size={'small'}
              sx={{
                width: 150,
                '& .MuiOutlinedInput-input': {
                  textAlign: 'end',
                },
              }}
              value={movePage}
              id={'go-page'}
              label={'페이지 이동'}
              onKeyDown={async (e) => {
                if (e.key === 'Enter') {
                  if (Number(movePage) < 1) {
                    await normalAlert('이동할 수 있는 페이지 범위를 벗어났습니다.')
                  } else {
                    await setFilter({...filter, page: movePage})
                  }
                }
              }}
              onChange={async (e) => {
                if (!/^\d*$/.test(e.target.value)) {
                  await normalAlert('숫자만 입력 가능합니다.')
                  return
                } else {
                  if (Number(e.target.value) > Math.ceil(totalCount / (filter?.rowPerPage || 1))) {
                    await normalAlert('이동할 수 있는 페이지 범위를 벗어났습니다.')
                    return
                  } else {
                    setMovePage(Number(e.target.value))
                  }
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='move-page'
                      onClick={async () => {
                        if (!/^\d*$/.test(movePage)) {
                          await normalAlert('숫자만 입력 가능합니다.')
                          return
                        } else {
                          if (Number(movePage) < 1) {
                            await normalAlert('이동할 수 있는 페이지 범위를 벗어났습니다.')
                          } else {
                            await setFilter({...filter, page: movePage})
                          }
                        }
                      }}
                      edge='end'
                    >
                      <KeyboardDoubleArrowRight />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <FormControl sx={{width: 200}}>
            <InputLabel id='demo-simple-select-label'>한 페이지에 표시될 항목</InputLabel>
            <Select
              labelId='demo-simple-select-label'
              id='customer-target'
              label='한 페이지에 표시될 항목'
              // sx={{paddingY: 0}}
              size={'small'}
              value={filter?.rowPerPage}
              onChange={(e) => {
                setFilter({...filter, page: 1, rowPerPage: e.target.value})
              }}
            >
              {_.map(pageInfo.selectPageSize, (el, i) => {
                return (
                  <MenuItem value={el} key={i}>
                    {el}개 / 페이지 당
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        </div>
      )}
      {mini && (
        <div className={'mt-3 row gap-3 justify-content-center align-items-center'}>
          <Pagination
            count={Math.ceil(totalCount / (filter?.rowPerPage || 1))}
            color='primary'
            size={'large'}
            variant='outlined'
            shape='rounded'
            defaultPage={1}
            siblingCount={2}
            boundaryCount={1}
            page={filter?.page}
            onChange={(e, page) => {
              setFilter({...filter, page: page})
            }}
          />
          <FormControl sx={{width: 200}}>
            <InputLabel id='demo-simple-select-label'>한 페이지에 표시될 항목</InputLabel>
            <Select
              labelId='demo-simple-select-label'
              id='customer-target'
              label='한 페이지에 표시될 항목'
              // sx={{paddingY: 0}}
              size={'small'}
              value={filter?.rowPerPage}
              onChange={(e) => {
                setFilter({...filter, page: 1, rowPerPage: e.target.value})
              }}
            >
              {_.map(pageInfo.selectPageSize, (el, i) => {
                return (
                  <MenuItem value={el} key={i}>
                    {el}개 / 페이지 당
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
        </div>
      )}
    </>
  )
}

export default CustomPagination
